import React, { Component } from "react";
import { Table, Button } from "antd";
import {
  RightOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { apiDriver } from "../../../../api/api-driver";
import { emitter } from "../../../../common/utils/emitter";
import { SearchBar } from "./search-bar";
import { DriverDetail } from "../driver-detail/driver-detail";
import { alert } from "../../../../common/utils/alert";
import moment from "moment";

const STATUS_DATA = {
  0: "Không thể điều động",
  1: "Chờ điều động",
  2: "Đã điều động",
};

export class DriverList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isShowDetail: false,
      typeOption: "create_new",
      isAddDriver: false,
      dataChoose: null,
      journey_diarys: [],
      dateForPaymentRequest: {},
      exportFilter: {
        birthdate: null,
        idCard: null,
        mobile: null,
        name: null,
        status: null,
        user_group: {
          id: null,
        },
      },
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Tài xế",
        dataIndex: "name",
        key: "name",
        render: (item) => (
          <div style={{ minWidth: 200, textAlign: "left" }}>{item}</div>
        ),
      },
      {
        title: "Mã số cá nhân",
        dataIndex: "id_card",
        key: "id_card",
        render: (item) => (
          <div style={{ minWidth: 120, textAlign: "center" }}>{item}</div>
        ),
      },
      {
        title: "Ngày sinh",
        dataIndex: "birthdate",
        key: "birthdate",
        render: (item) => {
          const time_unix = moment(item).format("DD/MM/YYYY");
          return item ? (
            <div style={{ minWidth: 120, textAlign: "center" }}>
              {time_unix}
            </div>
          ) : null;
        },
      },
      {
        title: "Số điện thoại",
        dataIndex: "data",
        key: "mobile",
        render: (data) => (
          <div style={{ minWidth: 100, textAlign: "center" }}>
            +{data.country_code}
            {data.mobile}
          </div>
        ),
      },
      {
        title: "Nguồn nhân sự",
        dataIndex: "user_group_id",
        key: "user_group_id",
        render: (item) => (
          <div style={{ minWidth: 120, textAlign: "center" }}>
            {item ? item.name : ""}
          </div>
        ),
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        render: (status) => (
          <div style={{ minWidth: 120, textAlign: "center" }}>
            {STATUS_DATA[status]}
          </div>
        ),
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "detail",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  getData = async (page) => {
    const { state } = this.search;
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    if (state.checkSearch) {
      this.setState({
        exportFilter: {
          branch_id: state?.branch_id || null,
          birthdate: state.birthdate ? state.birthdate : null,
          id_card: state.idCard
            ? `%${state.idCard.trim().replace(/%/gi, "\\%")}%`
            : null,
          mobile_full: state.mobile
            ? `%${state.mobile.trim().replace(/%/gi, "\\%")}%`
            : null,
          name: state.name
            ? `%${state.name.trim().replace(/%/gi, "\\%")}%`
            : null,
          status:
            state.status && state.status > 0
              ? state.status
              : state.status === 0
              ? state.status
              : null,
          user_group: {
            id:
              state.user_group && state.user_group >= 0
                ? state.user_group
                : null,
          },
        },
      });
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiDriver.getDrivers(this.state.exportFilter, page);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
            status: this.getStatus(value),
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.totalElements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  getStatus = (contract) => {
    if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === false
    ) {
      return contract.status;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === false
    ) {
      return 7;
    } else if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 6;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 8;
    }

    return contract.status;
  };

  componentDidMount() {
    this.getData(1);
  }
  showDetail = (data) => {
    this.handleAddDriver(true, "show_detail", data);
  };

  handleAddDriver = (status, type, data) => {
    this.setState({ isAddDriver: status, typeOption: type }, () => {
      const element = document.getElementById("right-layout");
      element.scrollTo(0, 0);
      if (data) {
        if (data.user_group_id.id === 3) {
          this.addDriver.setResources(data.user_group_id);
        }
        this.addDriver.updateFormDriver(data);
      }
      if (!status) {
        this.getData(1);
      }
    });
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page, false);
  };

  handleExportDriver = async () => {
    try {
      const { total, exportFilter } = this.state;
      const totalItem = total < 10 ? 10 : total;
      emitter.emit("FETCH_LOADING", true);
      apiDriver.exportDriver(exportFilter, 1, totalItem).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  render() {
    const { dataTable, total, isAddDriver, typeOption } = this.state;
    return (
      <div className="contract-table">
        {!isAddDriver ? (
          <>
            <div
              style={{
                color: "#d20a30",
                paddingTop: "20px",
                fontSize: "1em",
                display: "flex",
                alignItems: "center",
              }}
            >
              Danh sách tài xế
            </div>
            <SearchBar
              search={this.getData}
              ref={(ref) => (this.search = ref)}
            />
            <Table
              rowKey={(record) => record.customer_id}
              style={{ width: "100%" }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.customerTable}
            />
            <div className="button-container">
              <Button
                onClick={() => this.handleAddDriver(true, "create_new")}
                className="add-btn"
              >
                <PlusOutlined /> Thêm tài xế
              </Button>
              <Button className="export-btn" onClick={this.handleExportDriver}>
                <PrinterOutlined /> Export
              </Button>
            </div>
          </>
        ) : (
          <DriverDetail
            typeOption={typeOption}
            ref={(ref) => (this.addDriver = ref)}
            close={() => this.handleAddDriver(false)}
          />
        )}
      </div>
    );
  }
}
